import { readConsentCookie } from './consentCookie';
import { pushConsentDefault, pushConsentUpdate } from './cookieConsentMode';

/**
 * Initializes Google Consent Mode v2. Call once, as early as possible in the app
 * entry (the top of `index.jsx`, before React renders and before GTM is initialized
 * by `<GTagManager />`).
 *
 * 1. Sets the privacy-safe denied defaults.
 * 2. For a returning user who already chose, restores their saved consent
 *    synchronously so the FIRST `page_view` reflects it (Consent Mode v2 pitfall #3).
 *
 * Running here - before GTM is injected - means correctness no longer depends on
 * React effect / GTM init timing.
 */
export function bootstrapCookieConsentMode(): void {
    pushConsentDefault();
    const existing = readConsentCookie();
    if (existing) pushConsentUpdate(existing);
}
